//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { /*useContext, useEffect,*/ useContext, useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import SettingsIcon from '@material-ui/icons/Settings';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import PeopleIcon from '@material-ui/icons/People';
import LinkIcon from '@material-ui/icons/Link';
import LockIcon from '@material-ui/icons/Lock';
// import Navbar from '../helpers/Header';
// import LeftNavigation from '../LeftNavigation';
import { makeStyles } from '@material-ui/core';
import SimpleBar from 'simplebar-react';
import { useHistory, useParams } from 'react-router-dom';
import Divider from '@material-ui/core/Divider';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
import { logPageView } from '../system/firebase';
import Footer from '../dashboard/subComponents/Footer';
import { PATH_DASHBOARD } from '../system/constants';
import { AppContext, LayoutContext } from '../common/contexts';
import { setClassNameInDefns } from '../common/definitionHelper';
import { getFormattedDate, getUserDateFormat } from '../common/dateHelper';
import {
    BASE_URL,
    DASHBOARD_ID_MY_SETTINGS,
    DASHBOARD_ID_MY_SETTINGS_GENERAL,
    DASHBOARD_ID_MY_SETTINGS_LINK,
    DASHBOARD_ID_CHANGE_PASSWORD,
    DASHBOARD_ID_MY_SETTINGS_SUBSCRIPTION,
    DASHBOARD_ID_MY_SETTINGS_USERS,
    DASHBOARD_MY_SETTINGS,
    PAGE_TITLE_EMP_MY_SETTINGS,
} from '../common/constants';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdPageHead from '../common/elemental/AfitdPageHead';
import AfitdTypography from '../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
import Link from './subComponents/Link';
import General from './subComponents/General';
import SubscriptionAndBillingTabs from './subComponents/SubscriptionAndBillingTabs';
import Users from './subComponents/Users';
import ChangePassword from '../dashboardMySettings/subComponents/ChangePassword';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
import cx from 'clsx';
import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    const { pendingAccountSetup } = params;

    const navItemStyles = {
        padding: '10px 0',
        color: '#adadad',
        cursor: 'pointer',
        textAlign: 'left',
    };

    return makeStyles(theme => ({
        root: {
            height: '100%',
            background: '#FAFAFC',
        },
        header: {
            height: '128px',
        },
        content: {
            flex: 1,
            overflowY: 'hidden',
            marginTop: 0,
            marginBottom: 0,
            borderRadius: 10,
            backgroundColor: '#fff',
        },
        settingsRight: {
            overflowY: 'auto',
            height: '100%',
            '&::-webkit-scrollbar-track': {
                borderRadius: '10px',
                background: 'none',
            },
            '&::-webkit-scrollbar': {
                width: '8px',
                backgroundColor: '#F5F5F5',
            },
            '&::-webkit-scrollbar-thumb': {
                borderRadius: '10px',
                backgroundColor: 'rgba(0,0,0,0.2)',
            },
            [theme.breakpoints.down('lg')]: { padding: '0px 0 50px 40px' },
            // [theme.breakpoints.down('sm')]: { paddingLeft: 16, paddingRight: 16 },
            [theme.breakpoints.down('sm')]: { padding: '0px' },
        },

        headerTitle: {
            marginTop: '38px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
            [theme.breakpoints.down('sm')]: { marginTop: '50px' },
        },
        headerToday: {
            marginTop: 7,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
        },
        calendarIcon: { color: 'rgba(17, 30, 20, 0.6)', fontSize: 16 },
        todayContainer: {
            marginTop: '1px',
            marginLeft: '9px',
            fontSize: '13px',
            color: 'rgba(17, 30, 20, 0.6)',
        },
        title: {
            fontStyle: 'normal',
            fontWeight: '500',
            fontSize: '26px',
            lineHeight: '30px',
            color: '#111E14',
        },
        dateBox: {
            display: 'flex',
            alignItems: 'center',
        },
        date: {
            color: 'rgba(17, 30, 20, 0.6)',
            marginLeft: '5px',
        },

        navList: {
            listStyle: 'none',
            padding: '20px 0 0 50px',
            marginTop: 0,
            marginBottom: 0,
            [theme.breakpoints.down('lg')]: {
                display: 'flex',
                justifyContent: 'space-between',
                padding: '32px 40px 0 40px',
            },
            [theme.breakpoints.down('sm')]: {
                padding: '0 10px',
                // marginLeft: '-38px',
            },
            // [theme.breakpoints.down('md')]: {
            //     padding: '10px 0 0 10px',
            // },
        },
        navItem: {
            padding: '10px 0',
            color: '#adadad',
            cursor: pendingAccountSetup ? 'default' : 'pointer',
            textAlign: 'left',
            fontSize: '16px',
            [theme.breakpoints.down('sm')]: {
                paddingTop: 16,
            },
        },
        navItemActive: {
            fontSize: '16px',
            color: 'black',
            fontWeight: 'bold',
            [theme.breakpoints.down('sm')]: {
                paddingTop: 16,
            },
        },

        settingsContainer: {
            padding: '30px 50px 40px 0',
            [theme.breakpoints.down('md')]: {
                padding: '40px 10px 40px 0',
            },
        },
        settingsLeftDivider: {
            padding: '16px 40px 0 40px',
            // [theme.breakpoints.down('sm')]: { paddingLeft: 16, paddingRight: 16 },
            [theme.breakpoints.down('sm')]: { padding: '0px' },
        },
        generalNavList: {
            [theme.breakpoints.down('sm')]: {
                fontSize: '14pt',
            },
        },
        myLinkNavList: {
            ...navItemStyles,
            [theme.breakpoints.down('sm')]: {
                fontSize: '14pt',
            },
        },
        usersNavList: {
            ...navItemStyles,
            [theme.breakpoints.down('sm')]: {
                fontSize: '14pt',
            },
        },
        subscriptionNavList: {
            ...navItemStyles,
            [theme.breakpoints.down('sm')]: {
                fontSize: '14pt',
            },
        },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes, pendingAccountSetup, userDateFormat, history, activeSubPageId, isAdmin } = params;
    const { navItem: navItemCls, navItemActive: navItemActiveCls /*, content*/ } = classes;

    const isGeneralActive = activeSubPageId === SUBPAGE_ID_GENERAL;
    const isMyLinkActive = activeSubPageId === SUBPAGE_ID_MY_URL;
    const isChangePasswordActive = activeSubPageId === SUBPAGE_ID_CHANGE_PASSWORD;
    const isSubscriptionActive = activeSubPageId === SUBPAGE_ID_SUBSCRIPTION;
    const isUsersActive = activeSubPageId === SUBPAGE_ID_USERS;

    const defns = {
        root: { item: true, container: true, direction: 'column', lg: 12, md: 12, sm: 12, xs: 12 },
        content: { container: true, item: true, spacing: 0 },
        date: { variant: 'body2' },
        header: { item: true },

        // SIDE MENU
        settingsLeft: { item: true, xl: 3, lg: 12, md: 12, sm: 12, xs: 12 },
        navList: {},
        generalNavList: {
            className: cx(navItemCls, { [navItemActiveCls]: isGeneralActive }),
            onClick: pendingAccountSetup ? undefined : () => history.push(`${BASE_URL}${PATH_DASHBOARD}/${DASHBOARD_ID_MY_SETTINGS}/${DASHBOARD_ID_MY_SETTINGS_GENERAL}`),
        },
        myLinkNavList: {
            className: cx(navItemCls, { [navItemActiveCls]: isMyLinkActive }),
            onClick: () => history.push(`${BASE_URL}${PATH_DASHBOARD}/${DASHBOARD_ID_MY_SETTINGS}/${DASHBOARD_ID_MY_SETTINGS_LINK}`),
        },
        changePassword: {
            className: cx(navItemCls, { [navItemActiveCls]: isChangePasswordActive }),
            onClick: () => history.push(`${BASE_URL}${PATH_DASHBOARD}/${DASHBOARD_ID_MY_SETTINGS}/${DASHBOARD_ID_CHANGE_PASSWORD}`),
        },
        usersNavList: {
            className: cx(navItemCls, { [navItemActiveCls]: isUsersActive }),
            onClick: () => history.push(`${BASE_URL}${PATH_DASHBOARD}/${DASHBOARD_ID_MY_SETTINGS}/${DASHBOARD_ID_MY_SETTINGS_USERS}`),
        },
        subscriptionNavList: {
            className: cx(navItemCls, { [navItemActiveCls]: isSubscriptionActive }),
            onClick: pendingAccountSetup ? undefined : () => history.push(`${BASE_URL}${PATH_DASHBOARD}/${DASHBOARD_ID_MY_SETTINGS}/${DASHBOARD_ID_MY_SETTINGS_SUBSCRIPTION}`),
        },

        // CONTENT
        settingsRight: { item: true, xl: 9, lg: 12, md: 12, sm: 12, xs: 12 },
        todayText: { variant: 'caption', value: getFormattedDate(new Date(), userDateFormat), clsBigCaption: true },
        isAdminDefn: { isAdmin },
    };

    setClassNameInDefns(defns, classes);
    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------
const SUBPAGE_ID_GENERAL = 'general';
const SUBPAGE_ID_SUBSCRIPTION = 'subscription';
const SUBPAGE_ID_USERS = 'users';
const SUBPAGE_ID_MY_URL = 'my-url';
const SUBPAGE_ID_CHANGE_PASSWORD = 'changePassword';

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const MySettings = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const appContext = useContext(AppContext);
    const { currentEmployer, userId, pendingAccountSetup, currentUser } = appContext;
    const authTypeEmail = _get(currentUser, 'authTypeEmail');
    const stripeCusId = currentEmployer?.stripeCusId;

    const members = _get(currentEmployer, 'members', []);
    const layoutContext = useContext(LayoutContext);
    const history = useHistory();
    const { subPageId } = useParams();
    const userDateFormat = getUserDateFormat(appContext);

    const theme = useTheme();
    const lgMatches = useMediaQuery(theme.breakpoints.down('lg'));
    const mdMatches = useMediaQuery(theme.breakpoints.down('md'));
    const smMatches = useMediaQuery(theme.breakpoints.down('sm'));

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { propExample } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    const defaultSubPageId = subPageId === 'u' ? SUBPAGE_ID_USERS : SUBPAGE_ID_GENERAL;
    const [activeSubPageId, setActiveSubPageId] = useState(defaultSubPageId);
    const [firstTimeData, setFirstTimeData] = useState();

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    useEffect(() => {
        logPageView(PAGE_TITLE_EMP_MY_SETTINGS);
    }, []);

    useEffect(() => {
        switch (subPageId) {
            case DASHBOARD_ID_MY_SETTINGS_SUBSCRIPTION:
                setActiveSubPageId(SUBPAGE_ID_SUBSCRIPTION);
                break;
            case DASHBOARD_ID_MY_SETTINGS_USERS:
                setActiveSubPageId(SUBPAGE_ID_USERS);
                break;
            case DASHBOARD_ID_MY_SETTINGS_LINK:
                setActiveSubPageId(SUBPAGE_ID_MY_URL);
                break;
            case DASHBOARD_ID_CHANGE_PASSWORD:
                setActiveSubPageId(SUBPAGE_ID_CHANGE_PASSWORD);
                break;
            default:
                // TEMP TEMP TEMP TEMP
                // TEMP TEMP TEMP TEMP
                // TEMP TEMP TEMP TEMP
                // TEMP TEMP TEMP TEMP
                setActiveSubPageId(SUBPAGE_ID_GENERAL);
            // setActiveSubPageId(SUBPAGE_ID_SUBSCRIPTION);
            // TEMP TEMP TEMP TEMP
            // TEMP TEMP TEMP TEMP
            // TEMP TEMP TEMP TEMP
            // TEMP TEMP TEMP TEMP
            // TEMP TEMP TEMP TEMP
        }
    }, [subPageId, stripeCusId]);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------
    const isAdmin = Boolean(members.find(el => el.userId === userId && (el.isAdmin || el.isOwner)));

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const accountSetupGoToSubscription = ({ data } = {}) => {
        // setFirstTimeData(ftData => ({ ...ftData, ...data }));
        setActiveSubPageId(SUBPAGE_ID_SUBSCRIPTION);
    };

    const accountSetupGoToGeneral = ({ data }) => {
        setFirstTimeData(ftData => ({ ...ftData, ...data }));
        setActiveSubPageId(SUBPAGE_ID_GENERAL);
    };

    // if a 'user' member is trying to view the Billing and Subscription page, redirect to General
    if (!isAdmin && activeSubPageId === SUBPAGE_ID_SUBSCRIPTION) {
        history.push(`${BASE_URL}${PATH_DASHBOARD}/${DASHBOARD_ID_MY_SETTINGS}`);
    }

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const classes = useStyles({ pendingAccountSetup })();
    const defns = getDefns({ classes, pendingAccountSetup, userDateFormat, history, activeSubPageId, setActiveSubPageId, isAdmin });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <LayoutContext.Provider value={{ ...layoutContext, accountSetupGoToSubscription, accountSetupGoToGeneral, firstTimeData }}>
            <AfitdPageHead title={PAGE_TITLE_EMP_MY_SETTINGS} />
            <Grid {...defns.root}>
                <Grid {...defns.header}>
                    <div {...defns.headerTitle}>
                        <div {...defns.title}>{DASHBOARD_MY_SETTINGS}</div>
                    </div>
                    <div {...defns.headerToday}>
                        <CalendarTodayIcon {...defns.calendarIcon} />
                        <div {...defns.todayContainer}>
                            <AfitdTypography {...defns.todayText} />
                        </div>
                    </div>
                </Grid>
                <Grid {...defns.content}>
                    <Grid {...defns.settingsLeft}>
                        {smMatches ? (
                            <ul {...defns.navList}>
                                <li {...defns.generalNavList}>
                                    <SettingsIcon />
                                </li>
                                {isAdmin && (
                                    <li {...defns.subscriptionNavList}>
                                        <LocalAtmIcon />
                                    </li>
                                )}
                                {!pendingAccountSetup && (
                                    <li {...defns.usersNavList}>
                                        <PeopleIcon />
                                    </li>
                                )}
                                {!pendingAccountSetup && (
                                    <li {...defns.myLinkNavList}>
                                        <LinkIcon />
                                    </li>
                                )}
                                {!pendingAccountSetup && authTypeEmail && (
                                    <li {...defns.changePassword}>
                                        <LockIcon />
                                    </li>
                                )}
                            </ul>
                        ) : (
                            <ul {...defns.navList}>
                                <li {...defns.generalNavList}>{pendingAccountSetup ? 'General Information' : 'General'}</li>
                                {/* {isAdmin && <li {...defns.subscriptionNavList}>{pendingAccountSetup ? 'Subscription and Payment' : 'Subscription and Billing'}</li>} */}
                                {isAdmin && <li {...defns.subscriptionNavList}>Manage Subscription</li>}
                                {!pendingAccountSetup && <li {...defns.usersNavList}>Users</li>}
                                {!pendingAccountSetup && <li {...defns.myLinkNavList}>My URL</li>}
                                {!pendingAccountSetup && authTypeEmail && <li {...defns.changePassword}>Change My Password</li>}
                            </ul>
                        )}
                        {lgMatches ? (
                            <div {...defns.settingsLeftDivider}>
                                <Divider />
                            </div>
                        ) : null}
                    </Grid>
                    <Grid {...defns.settingsRight}>
                        <SimpleBar style={{ height: '100%' }}>
                            <div {...defns.settingsContainer}>
                                {activeSubPageId === SUBPAGE_ID_GENERAL && <General {...defns.isAdminDefn} />}
                                {activeSubPageId === SUBPAGE_ID_MY_URL && <Link {...defns.isAdminDefn} />}
                                {isAdmin && activeSubPageId === SUBPAGE_ID_SUBSCRIPTION && <SubscriptionAndBillingTabs />}
                                {activeSubPageId === SUBPAGE_ID_USERS && <Users {...defns.isAdminDefn} />}
                                {activeSubPageId === SUBPAGE_ID_CHANGE_PASSWORD && authTypeEmail && <ChangePassword />}
                            </div>
                        </SimpleBar>
                    </Grid>
                </Grid>
                <Grid {...defns.bottomFooter}>{mdMatches ? <Footer /> : null}</Grid>
            </Grid>
        </LayoutContext.Provider>
    );
};

export default MySettings;
